import { render } from "./ChangeMemberInfoPage.vue?vue&type=template&id=6609310c"
import script from "./ChangeMemberInfoPage.vue?vue&type=script&lang=js"
export * from "./ChangeMemberInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__